import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const ArtistIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="smallIcon">
        <g id="Vector 442">
          <path
            d="M4.26973 13C3.34988 11.6448 2.0621 8.56494 4.26973 7.08659C3.92495 5.60823 4.06324 2.72544 7.37469 3.02111C11.514 3.3907 14.6185 7.08659 12.2039 13C12.3189 11.1521 11.9969 7.53009 9.78929 7.82576C7.58165 8.12143 5.87994 7.94896 5.30503 7.82576C4.49985 8.31855 3.16553 10.0433 4.26973 13Z"
            fill={fillColor || 'white'}
          />
          <path
            d="M4.26973 7.08659C2.0621 8.56494 3.34988 11.6448 4.26973 13C3.16553 10.0433 4.49985 8.31855 5.30503 7.82576M4.26973 7.08659L5.30503 7.82576M4.26973 7.08659C3.92495 5.60823 4.06324 2.72544 7.37469 3.02111C11.514 3.3907 14.6185 7.08659 12.2039 13C12.3189 11.1521 11.9969 7.53009 9.78929 7.82576C7.58165 8.12143 5.87994 7.94896 5.30503 7.82576"
            stroke={fillColor || 'white'}
          />
        </g>
      </g>
    </svg>
  );
};

export { ArtistIcon };
